import { render, staticRenderFns } from "./VehicleCarryWeightList.vue?vue&type=template&id=0c519e90&lang=pug"
import script from "./VehicleCarryWeightList.vue?vue&type=script&lang=js"
export * from "./VehicleCarryWeightList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports